import { useState } from 'react';
import { useApi } from '../hooks';
import { Chargement, MessageErreur, Pagination, formatDate } from '../components/ui';

const ENTITES = [
  ['', 'Tout'],
  ['clients', 'Clients'],
  ['workstations', 'Postes'],
  ['workstation_software', 'Logiciels des postes'],
  ['software', 'Logiciels'],
  ['software_versions', 'Versions'],
  ['update_history', 'Mises à jour'],
  ['users', 'Utilisateurs'],
];

/** Résumé lisible des valeurs enregistrées (avant → après) */
function resumer(log) {
  const valeurs = log.newValues || log.oldValues;
  if (!valeurs || typeof valeurs !== 'object') return '';
  return ['name', 'licenseKey', 'logiciel', 'version', 'message', 'updateAllowed']
    .filter((cle) => valeurs[cle] !== undefined && valeurs[cle] !== null)
    .map((cle) => `${cle} : ${valeurs[cle]}`)
    .join(' · ');
}

export default function Historique() {
  const [entityType, setEntityType] = useState('');
  const [page, setPage] = useState(1);
  const { donnees, erreur, chargement } = useApi('/historique', { entityType, page });

  return (
    <>
      <h1>Historique</h1>
      <div className="barre-filtres">
        <select
          value={entityType}
          onChange={(e) => {
            setEntityType(e.target.value);
            setPage(1);
          }}
        >
          {ENTITES.map(([valeur, libelle]) => (
            <option key={valeur} value={valeur}>
              {libelle}
            </option>
          ))}
        </select>
      </div>

      <MessageErreur erreur={erreur} />
      {chargement && !donnees ? (
        <Chargement />
      ) : (
        donnees && (
          <div className="carte">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Action</th>
                  <th>Élément</th>
                  <th>Détails</th>
                  <th>Par</th>
                </tr>
              </thead>
              <tbody>
                {donnees.donnees.map((log) => (
                  <tr key={log.id}>
                    <td>{formatDate(log.createdAt, true)}</td>
                    <td>{log.action}</td>
                    <td>
                      {log.entityType} {log.entityId && <span className="muted">#{log.entityId}</span>}
                    </td>
                    <td className="muted">{resumer(log)}</td>
                    <td>{log.user?.username ?? '—'}</td>
                  </tr>
                ))}
                {donnees.donnees.length === 0 && (
                  <tr>
                    <td colSpan={5} className="muted">
                      Aucune action enregistrée.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination pagination={donnees.pagination} onPage={setPage} />
          </div>
        )
      )}
    </>
  );
}
